exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root_283hE3x9Cm {\n  width: 800px;\n  padding: 72px 24px 32px 24px;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "root_283hE3x9Cm"
};